import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest, TransactionDownloadRequest } from "shared/models/transaction.model";
import moment from "moment";
import { DisbursementDownloadRequest } from "shared/models/disbursements.model";
import { ChargeAutomationDownloadRequest } from "shared/models/chargeAuto.models";
import { Chargeback, ChargebackDownload, ChargebackRequest } from "shared/models/chargeback.model";
import { DataResponse } from "shared/models";
import { FileName } from "constants/common.constants";

export const fileDownloadService = createApi({
  reducerPath: "fileDownloadService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    confirmDownload: builder.query<any, { fileDownloadId: number }>({
      query: (params) => ({
        url: `/confirm-download/${params?.fileDownloadId}`,
        method: "GET",
        headers: {
          PageName: "File Download",
        },
      }),
    }),
  }),
});

export const {
  useLazyConfirmDownloadQuery,
} = fileDownloadService;
